import React, { useState } from 'react';
import divider from '../../assets/divider-img.png';
import e1 from '../../assets/home-feature/hfp1.png';
import e2 from '../../assets/home-feature/hfp2.png';
import e3 from '../../assets/home-feature/hfp3.png';
import e4 from '../../assets/home-feature/hfp4.png';
import { Link } from 'react-router-dom';

const allGalleryItems = [
  {
    id: 1,
    category: 'Cryptocurrencies',
    imageSrc: e1,
    linkTo: 'project-details',
    title: 'Project Name',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },

  {
    id: 2,
    category: 'Stock',
    imageSrc: e2,
    linkTo: 'project-details',
    title: 'Project Name',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },

  {
    id: 3,
    category: 'Forex',
    imageSrc: e3,
    linkTo: 'project-details',
    title: 'Project Name',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },

  {
    id: 4,
    category: 'Cryptocurrencies',
    imageSrc: e4,
    linkTo: 'project-details',
    title: 'Project Name',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },

  {
    id: 5,
    category: 'Cryptocurrencies',
    imageSrc: e1,
    linkTo: 'project-details',
    title: 'Project Name',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },

  {
    id: 6,
    category: 'Stock',
    imageSrc: e2,
    linkTo: 'project-details',
    title: 'Project Name',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },

  {
    id: 7,
    category: 'Forex',
    imageSrc: e3,
    linkTo: 'project-details',
    title: 'Project Name',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },

  {
    id: 8,
    category: 'Cryptocurrencies',
    imageSrc: e4,
    linkTo: 'project-details',
    title: 'Project Name',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
];

const ProjectsPortolio = () => {
  const [selectedFilter, setSelectedFilter] = useState('All');

  const handleFilterClick = (filter) => {
    setSelectedFilter(filter);
  };

  const filteredGalleryItems =
    selectedFilter === 'All'
      ? allGalleryItems
      : allGalleryItems.filter((item) => item.category === selectedFilter);

  return (
    <div className="projects-portfolio">
      <div className="container">
        <div className="center-heading-description">
          <h2>Some Awesome Portfolio</h2>
          <div className="divider">
            <img src={divider} alt="divider" />
          </div>
          <p>
            These impressive portfolios serve as your window into the world of
            financial possibilities with Quantome, offering a glimpse into the
            potential of your own financial journey.
          </p>
        </div>

        <div className="projects-portfolio-wrapper">
          <div className="filter-buttons">
            <button
              className={selectedFilter === 'All' ? 'active' : ''}
              onClick={() => handleFilterClick('All')}
            >
              All
            </button>
            <button
              className={selectedFilter === 'Cryptocurrencies' ? 'active' : ''}
              onClick={() => handleFilterClick('Cryptocurrencies')}
            >
              Cryptocurrencies
            </button>
            <button
              className={selectedFilter === 'Stock' ? 'active' : ''}
              onClick={() => handleFilterClick('Stock')}
            >
              Stock
            </button>
            <button
              className={selectedFilter === 'Forex' ? 'active' : ''}
              onClick={() => handleFilterClick('Forex')}
            >
              Forex
            </button>
          </div>
          <div className="projects-gallery">
            {filteredGalleryItems.map((item) => (
              <Link key={item.id} to={item.linkTo} className="gallery-item">
                <div className="slide expert feature portfolio-items">
                  <div className="slide-content expert-content feature-content">
                    <img src={item.imageSrc} alt="experts" />
                    <div className="slide-info expert-info feature-info">
                      <h5>{item.category}</h5>
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsPortolio;
